export default __webpack_public_path__ + "static/media/generation-method.21f8665e.png";